exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".child_page[data-v-7427b2c6]{padding:15px}.data_wrap[data-v-7427b2c6]{padding:20px 0;background-color:#ffffff;border-radius:0 0 10px 10px}.money_icon[data-v-7427b2c6]{width:55px;height:55px;margin-right:15px}.money_data[data-v-7427b2c6]{font-size:28px;margin-top:10px}\n", ""]);

// exports
